/**
 * Faculty 6 — Testimonial-style carousel: a centered title + description above a
 * one-card-per-view carousel of faculty/student cards. Each card has a circular
 * photo with an optional play button (opens a video), a short quote, a name and
 * a role. Reuses existing faculty columns (`title`, `title_text_color`,
 * `title_1_color`, `description`, `description_text_color`, `background_color`)
 * and stores the cards in the `metadata` JSON — no new columns, only an ENUM
 * widen (see migration 20260602120000-faculty-variant-6-enum.js).
 */

export const FACULTY_6_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    priority: 1,
    status: true,
    metaImg: "",
    altImg: "",
    metaVideo: "",
    metaTitle: "Student Name",
    metaRole: "Designation, Company",
    metaDescription:
      "A short testimonial quote about the program experience and outcomes.",
  },

  METADATA_TITLES: {
    metadata: "Testimonial Cards",
  },

  FACULTY_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      description:
        "Wrap words in { } to colour them with the highlight colour below. Press Enter to break the line — use that (not {{ }}) when the next line should start with the highlight.",
      value: "Success Stories - Hear from\n{Our Students}",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Success Stories - Hear from\n{Our Students}",
      required: false,
      defaultValue: "Success Stories - Hear from\n{Our Students}",
      rows: 2,
    },
    {
      fieldName: "title_text_color",
      label: "Title / text color",
      value: "#1A1A1A",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#1A1A1A",
      required: false,
      defaultValue: "#1A1A1A",
    },
    {
      fieldName: "title_1_color",
      label: "Title highlight color (for {...} text)",
      value: "#E1473F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E1473F",
      required: false,
      defaultValue: "#E1473F",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Short supporting line under the title",
      required: false,
      rows: 2,
    },
    {
      fieldName: "description_text_color",
      label: "Description text color",
      value: "#1A1A1A",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#1A1A1A",
      required: false,
      defaultValue: "#1A1A1A",
    },
    {
      fieldName: "background_color",
      label: "Section background color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Sort order (1, 2, 3…)",
      required: true,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/Hide this card",
      defaultValue: true,
    },
    {
      header: "Photo",
      fieldName: "metaImg",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload photo (square, shown in a circle)",
    },
    {
      header: "Photo alt text",
      fieldName: "altImg",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the photo",
    },
    {
      header: "Video URL (optional)",
      fieldName: "metaVideo",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "YouTube or direct video URL — adds a play button",
    },
    {
      header: "Name",
      fieldName: "metaTitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Person name",
    },
    {
      header: "Role / designation",
      fieldName: "metaRole",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Designation, Company",
    },
    {
      header: "Quote / testimonial",
      fieldName: "metaDescription",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Short testimonial quote",
      rows: 4,
    },
  ],
};
